module.exports = __webpack_public_path__ + "img/Items.3d2bd020.svg";